/** @jsxImportSource @emotion/react */
import { useReducer, useEffect } from "react";
import { useLayout } from "library/hooks/useLayout";
import { Layout } from "../Layout/Layout";
import { BpayLanding } from "./BpayLanding";
import { BpayForm } from "./BpayForm";
import { BpayOneTimeCode } from "./BpayOneTimeCode";
import { BpaySuccess } from "./BpaySuccess";
import { BpayError } from "./BpayError";
import { PAGES, initialBpayState, bpayReducer } from "./bpayReducer";

const pageInfo = {
  [PAGES.LANDING]: {
    heading: "Pay BPAY bill",
    screenComponent: BpayLanding,
  },
  [PAGES.FORM]: {
    heading: "Pay BPAY bill",
    screenComponent: BpayForm,
  },
  [PAGES.ONE_TIME_CODE]: {
    heading: "Pay BPAY bill",
    screenComponent: BpayOneTimeCode,
  },
  [PAGES.SUCCESS]: {
    heading: "BPAY bill paid successfully",
    headingIcon: "success",
    screenComponent: BpaySuccess,
  },
  [PAGES.ERROR]: {
    heading: "Pay BPAY bill",
    screenComponent: BpayError,
  },
};

function BpayScreen({ screenComponent: ScreenComponent, state, dispatch }) {
  const { scrollToTop } = useLayout();

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop, ScreenComponent]);

  return (
    <div css={{ minHeight: 560 }}>
      <ScreenComponent state={state} dispatch={dispatch} />
    </div>
  );
}

function Bpay() {
  const [state, dispatch] = useReducer(bpayReducer, initialBpayState);
  const { page } = state;
  const {
    heading: pageHeading,
    headingIcon: pageHeadingIcon,
    screenComponent,
  } = pageInfo[page];

  return (
    <Layout>
      <Layout.Header icon={pageHeadingIcon}>{pageHeading}</Layout.Header>
      <Layout.Main>
        <BpayScreen
          screenComponent={screenComponent}
          state={state}
          dispatch={dispatch}
        />
      </Layout.Main>
    </Layout>
  );
}

export { Bpay };
